import { useScene } from "../store";
import { useT } from "../i18n";
import { CREDITS, LICENSE, SSS_PAGE, TEXTURE_ASSETS } from "../scene/assets";

/** 素材署名面板（CC BY 4.0 要求署名）。内容全部来自 scene/assets.ts，与实际加载的文件一致。 */
export function Credits() {
  const { t, lang } = useT();
  const open = useScene((s) => s.creditsOpen), setOpen = useScene((s) => s.setCreditsOpen);
  if (!open) return null;
  return (
    <div className="modal-bg" onClick={() => setOpen(false)}>
      <section className="modal glass" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true" aria-label={t("creditsTitle")}>
        <header><b>{t("creditsTitle")}</b><button onClick={() => setOpen(false)} aria-label={t("close")}>✕</button></header>
        <div className="body">
          <p>{t("creditsNote")}</p>
          {CREDITS.map((c) => (
            <div key={c.name} className="credit">
              <b>{c.name}</b> — {c.by}<br />
              <span>{lang === "en" ? c.descEn : c.desc}</span><br />
              <span>{t("license")}：{c.license.name} · <a href={c.url} target="_blank" rel="noreferrer noopener">{c.url}</a></span>
            </div>
          ))}
          <h4>Textures</h4>
          <ul>
            {TEXTURE_ASSETS.map((a) => (<li key={a.id}>{a.label} <code>{a.file}</code>{a.note ? ` — ${a.note}` : ""}</li>))}
          </ul>
          <p className="note">{LICENSE.name}: <a href={LICENSE.url} target="_blank" rel="noreferrer noopener">{LICENSE.url}</a> · <a href={SSS_PAGE} target="_blank" rel="noreferrer noopener">{SSS_PAGE}</a></p>
        </div>
      </section>
    </div>
  );
}
